<template>
    <div class="profile-section mb-2 sticky-top">
        <div class="text-left">
            <span>
                <a href="javascript:void(0)" class="text-black" @click="openNav()">
                    <div class="menu-icon-container">
                        <ThreeLineMenuIcon />    
                        <!-- 🔴 Notification Dot -->
                        <!--<span 
                            v-if="requestCount > 0"
                            class="notification-dot"
                        ></span>-->
                    </div>
                </a>
                <a href="javascript:void(0)" class="text-black" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})">
                    <img :src="logo" height="25px" />
                </a>
            </span>
            <div class="float-right">
                <!--<a href="javascript:void(0)" class="text-black" @click="openEnrollmentQrCodePopup()">
                    <QrCodeIcon />   
                </a>&nbsp;-->
                <a href="javascript:void(0)" class="text-black" @click="getNotifications()">
                    <span class="unread-notification" v-if="unReadNotificationTotal > 0"></span>
                    <NotificationBellIcon />    
                </a>
                &nbsp;
                <a href="javascript:void(0)" class="text-black" @click="$router.push({ path: '/parent-profile', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.75 6C6.75 7.39239 7.30312 8.72774 8.28769 9.71231C9.27226 10.6969 10.6076 11.25 12 11.25C13.3924 11.25 14.7277 10.6969 15.7123 9.71231C16.6969 8.72774 17.25 7.39239 17.25 6C17.25 4.60761 16.6969 3.27226 15.7123 2.28769C14.7277 1.30312 13.3924 0.75 12 0.75C10.6076 0.75 9.27226 1.30312 8.28769 2.28769C7.30312 3.27226 6.75 4.60761 6.75 6Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.25 23.25C2.25 20.6641 3.27723 18.1842 5.10571 16.3557C6.93419 14.5272 9.41414 13.5 12 13.5C14.5859 13.5 17.0658 14.5272 18.8943 16.3557C20.7228 18.1842 21.75 20.6641 21.75 23.25" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
            </div>
        </div>
        <div id="mySidebar" class="sidebar">
            <a href="javascript:void(0)" @click="closeNav()">
                <img :src="logo" height="25px" /> Wingio
                <CrossCloseIcon class="float-right pt-1 pr-2" /> 
                <!--<i class="fas fa-times float-right pt-1 pr-2"></i>-->
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/kids-device', query:{ profileId: this.profileId }})" class="border-bottom" :class="{ 'active': routerName == 'Kids Devices' }">
                <DashboardIcon :iconClass="{ 'svg-icon-active': routerName === 'Kids Devices' }" />
                 Dashboard
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/play-store', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'Applications List' || routerName == 'Application' }">
                <ApplicationsIcon :iconClass="{ 'svg-icon-active': routerName === 'Applications List' }" />
                Apps
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/requests', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'requests' }">
                <AppRequestListIcon :iconClass="{ 'svg-icon-active': routerName === 'requests' }" />
                 Request
                <!-- Bootstrap badge -->
                <span v-if="requestCount > 0" class="badge bg-warning ms-2">
                    {{ requestCount }}
                </span>
            </a>
            <a href="javascript:void(0)"  @click="navigateTo({ path: '/geofence', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'geofence' }">
                <GeofenceIcon :iconClass="{ 'svg-icon-active': routerName === 'geofence' }" />
                 Location Alerts
                 <span class="badge bg-warning ms-2">
                    New
                </span>
            </a>
            <a href="javascript:void(0)" v-if="enableSchedule" @click="navigateTo({ path: '/schedule', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'schedule' }">
                <ScheduleIcon :iconClass="{ 'svg-icon-active': routerName === 'schedule' }" />
                 Schedule
                 <span class="badge bg-warning ms-2">
                    New
                </span>
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/global-settings', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'global-settings' }">
                <SettingIcon :iconClass="{ 'svg-icon-active': routerName === 'global-settings' }" />
                 Settings
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/contacts', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'contacts' }">
                <AddressBookIcon :iconClass="{ 'svg-icon-active': routerName === 'contacts' }" />
                Manage Contacts
                <!--<span class="coming-soon-badge">
                    Beta
                </span>-->
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/manage-chrome', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'manage-chrome' }">
                <ChromeIcon :iconClass="{ 'svg-icon-active': routerName === 'manage-chrome' }" />
                 Manage Chrome
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/timeline', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'timeline' }">
                <ReportIcon :iconClass="{ 'svg-icon-active': routerName === 'timeline' }" />
                 Timeline
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/reports', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'reports' }">
                <ReportIcon :iconClass="{ 'svg-icon-active': routerName === 'reports' }" />
                 Reports
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/device-info', query:{ profile_id: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'device-info' }">
                <DeviceIcon :iconClass="{ 'svg-icon-active': routerName === 'device-info' }" />
                Device
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/browser-logs', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'browser-logs' }">
                <BrowserLogIcons :iconClass="{ 'svg-icon-active': routerName === 'browser-logs' }" />
                 Browser Logs
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/payment-history', query:{ profileId: this.profileId }})" class="border-bottom" :class="{ 'active': routerName == 'payment-history' }">
                <PaymentHistoryIcon :iconClass="{ 'svg-icon-active': routerName === 'payment-history' }" />
                 Payment History
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/payment-methods', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'payment-methods' }">
                <PaymentMethodIcon :iconClass="{ 'svg-icon-active': routerName === 'payment-methods' }" />
                 Payment Methods
            </a>
            <a href="javascript:void(0)" @click="navigateTo({ path: '/change-password', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})" class="border-bottom" :class="{ 'active': routerName == 'change-password' }">
                <ChangePasswordIcon :iconClass="{ 'svg-icon-active': routerName === 'change-password' }" />
                 Change Password
            </a>
            <a href="javascript:void(0)" @click="logout()" class="border-bottom">
                <LogoutIcon />Logout
            </a>
            <span class="badge badge-danger text-left m-3 p-2" :style="{ 'width': '80%', 'background': '#FCD9E2', 'color': '#A7002D', 'margin-left': '30px !important' }">
                <a :style="{ 'font-size': '13px', 'padding': 'unset' }" href="javascript:void(0)" @click="$router.push({ path: '/contact-us', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})">
                    <NeedHelpIcon />
                    &nbsp; Need a help?</a>
            </span>
            <!--<div class="footer-menu-item">
                
            </div>-->
        </div>
        <div class="collapse m-2 footer" id="enrollmentQrCodePopup">
            <div class="card">
                <div class="card-body">
                    <h6 class="text-black">
                        <b>Enrollment QR Code</b> <a href="javascript:void(0)" class="text-black" @click="closeEnrollmentQrCodePopup()">
                            <CrossCloseIcon class="float-right pt-1 pr-2" /> 
                            <!--<i class="fas fa-times float-right pt-1 pr-2"></i>-->
                        </a></h6>
                    <hr>
                    <ol>
                        <li>Factory reset your device.</li>
                        <li>Tap the welcome screen six times in the same spot to launch the QR code scanner.</li>
                        <li>
                            Scan this QR Code on your devices.
                            <img src="images/KidDefaultQrCode.png" class="img-fluid" />
                        </li>
                        <li>After completing the enrollment process, you will find the Kids app on your device. Please open the app, log in, and then refresh this page.</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="collapse m-2 footer" id="logoutPopup">
            <div class="card">
                <div class="card-body">
                    <h6 class="text-black">
                        <b>Are you sure you want to log out?</b> <a href="javascript:void(0)" class="text-black" @click="closeLogoutPopup()">
                            <CrossCloseIcon class="float-right pt-1 pr-2" /> 
                        </a></h6>
                    <hr>
                    <button type="button" class="btn btn-danger" :style="{ 'border-radius': '30px', width: '100%' }" @click="doLogout()">Log out</button>
                </div>
            </div>
        </div>
        <div class="collapse mt-2 mr-2 footer-full" id="notificationsPopup">
            <div class="card height-100">
                <div class="card-body">
                    <h5 class="text-black">
                        <b>Notification Center</b> <a href="javascript:void(0)" class="text-black" @click="closeNotificationPopup()">
                            <CrossCloseIcon class="float-right pt-1 pr-2" /> 
                        </a></h5>
                    <hr>
                    <div class="container" :style="{ 'max-height': '90%' }">
                        <div class="row ScrollStyle">
                            <div class="col-lg-12 right" v-if="showLoader == true">
                                <div class="box shadow-sm rounded bg-white mb-2">
                                    <div class="box-body p-0 text-center">
                                        <i class="fa fa-spinner fa-spin"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 right" v-for="notification in notificationList" :key="notification._id">
                                <div class="box shadow-sm rounded bg-white mb-2">
                                    <div class="box-body p-0">
                                        <div class="p-2 d-flex align-items-center osahan-post-header">
                                            <div class="dropdown-list-image mr-2">
                                                <img v-if="notification.icon" class="rounded-circle" :src="notification.icon" alt="" />
                                                <img v-else class="rounded-circle" src="https://static.vecteezy.com/system/resources/thumbnails/022/059/000/small/no-image-available-icon-vector.jpg" alt="" />
                                            </div>
                                            <div class="font-weight-bold mr-3">
                                                <div class="mb-2">
                                                    <a v-if="['App Installed', 'App Disabled', 'App Enabled', 'Daily Limit Enabled', 'Daily Limit Disabled'].includes(notification.type)"  
                                                        @click="$router.push({ path: '/application', query: { package_name: notification?.packageName, profile_id: notification.profileId, serialNumber: notification.serialNumber, type: notification.type } })">{{ notification.message }}</a>
                                                    <a v-else-if="['App Request'].includes(notification.type)"  
                                                        @click="$router.push({ path: '/requests', query: {  profileId: notification.profileId, serialNumber: notification.serialNumber } })">{{ notification.message }}</a>
                                                    <label v-else>{{ notification.message }}</label>
                                                </div>
                                                <!--<button type="button" class="btn btn-outline-success btn-sm">Installed</button>-->
                                                <div v-if="notification.type" class="small" :class="notification.typeClass">
                                                    <b v-if="notification.type != 'Rate App'">{{ notification.type }}</b>
                                                    <a v-else href="javascript:void(0)" @click="$router.push({ path: '/application', query: { package_name: notification.packageName, profile_id: notification.profileId, serialNumber: notification.serialNumber, showRating: true } })">{{ notification.type }}</a>
                                                </div>
                                            </div>
                                            <span class="ml-auto mb-auto">
                                                <div class="text-right text-muted pt-1">
                                                    {{ notification.formattedTime }}
                                                </div>
                                                <div class="text-right text-muted pt-1">
                                                    {{ formatDate(notification.created_at) }}
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p v-if="notificationList.length == 0">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8 19.4627C15.8 21.5049 16.6112 23.4634 18.0553 24.9074C19.4993 26.3514 21.4578 27.1627 23.5 27.1627C25.5422 27.1627 27.5007 26.3514 28.9447 24.9074C30.3887 23.4634 31.2 21.5049 31.2 19.4627C31.2 17.4205 30.3887 15.462 28.9447 14.018C27.5007 12.5739 25.5422 11.7627 23.5 11.7627C21.4578 11.7627 19.4993 12.5739 18.0553 14.018C16.6112 15.462 15.8 17.4205 15.8 19.4627Z" stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M34.4998 30.4625L28.9456 24.9067" stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M34.5 12.8626C34.5002 11.8514 34.3012 10.85 33.9143 9.91571C33.5274 8.98141 32.9602 8.1325 32.2452 7.41745C31.5301 6.7024 30.6812 6.13523 29.7469 5.74833C28.8126 5.36144 27.8112 5.16241 26.8 5.1626H9.2C7.15783 5.1626 5.19931 5.97385 3.75528 7.41788C2.31125 8.86191 1.5 10.8204 1.5 12.8626C1.5 14.9048 2.31125 16.8633 3.75528 18.3073C5.19931 19.7513 7.15783 20.5626 9.2 20.5626H11.4" stroke="#737373" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                No data to show
                            </p>
                            <div class="col-lg-12 text-center p-2" v-if="totalNotificationsCount > (currentPage * limit)">
                                <button type="button" class="btn btn-primary" @click="showMoreNotifications()"><b>Show More</b></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="collapse m-2 footer" id="appRatingPopup">
            <div class="card height-100">
                <div class="card-body">
                    <h6 class="text-black">
                        <b>Please rate this/these Apps to help other parents</b> <a href="javascript:void(0)" class="text-black" @click="closeAppRatingPopup()">
                            <CrossCloseIcon class="float-right pt-1 pr-2" /> 
                        </a></h6>
                    <hr>
                    <div class="container" :style="{ 'max-height': '90%' }">
                        <div class="row ScrollStyle">
                            <div class="col-lg-12 right" v-for="app in pendingRatingApps" :key="app._id">
                                <div class="box shadow-sm rounded bg-white mb-2">
                                    <div class="box-body p-0">
                                        <div class="p-2 d-flex align-items-center osahan-post-header">
                                            <div class="dropdown-list-image mr-2">
                                                <img class="rounded-circle" :src="app.app_icon" alt="" />
                                            </div>
                                            <div class="font-weight-bold mr-3">
                                                <div class="mb-2 word-wrap-anywhere" v-if="app.playStoreDetail">{{ app.playStoreDetail.title }}</div>
                                                <div class="mb-2 word-wrap-anywhere" v-else>{{ app.package_name }}</div>
                                            </div>
                                            <span class="ml-auto mb-auto">
                                                <div class="text-right text-muted pt-1">
                                                    <button type="button" class="float-right mb-2 install-app-btn" @click="$router.push({ path: '/application', query: { package_name: app.package_name, profile_id: this.profileId, serialNumber: this.serialNumber, showRating: true } })" >Rate Now</button>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KidsService from "../services/KidsService";
import UserService from "../services/UserService";
import DashboardIcon from '@/components/icons/DashboardIcon.vue'
import ApplicationsIcon from '@/components/icons/ApplicationsIcon.vue'
import AppRequestListIcon from '@/components/icons/AppRequestListIcon.vue'
import BrowserLogIcons  from '@/components/icons/BrowserLogIcons.vue'
import PaymentHistoryIcon  from '@/components/icons/PaymentHistoryIcon.vue'
import PaymentMethodIcon from '@/components/icons/PaymentMethodIcon.vue'
import ChangePasswordIcon from '@/components/icons/ChangePasswordIcon.vue'
import ThreeLineMenuIcon from '@/components/icons/ThreeLineMenuIcon.vue'
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue'
import NeedHelpIcon from '@/components/icons/NeedHelpIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import QrCodeIcon from '@/components/icons/QrCodeIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import ScheduleIcon from '@/components/icons/ScheduleIcon.vue'
import SettingIcon from '@/components/icons/SettingIcon.vue'
import DeviceIcon from '@/components/icons/DeviceIcon.vue'
import AddressBookIcon from '@/components/icons/AddressBookIcon.vue'
import ReportIcon from '@/components/icons/ReportIcon.vue'
import GeofenceIcon from '@/components/icons/GeofenceIcon.vue'
import ChromeIcon  from '@/components/icons/ChromeIcon.vue'

export default {
  name: 'KidHeader',
  components: {
    ChromeIcon,
    ReportIcon,
    SettingIcon,
    DeviceIcon,
    AddressBookIcon,
    PaymentMethodIcon,
    DashboardIcon,
    ApplicationsIcon,
    AppRequestListIcon,
    BrowserLogIcons,
    PaymentHistoryIcon,
    ChangePasswordIcon,
    ThreeLineMenuIcon,
    NotificationBellIcon,
    NeedHelpIcon,
    LogoutIcon,
    QrCodeIcon,
    CrossCloseIcon,
    ScheduleIcon,
    GeofenceIcon
  },
  props: {
    serialNumber: String,
    profileId: String,
    logo: {
        type: String,
        default: "/images/lya-logo.png",
    },
  },
  data() {
    return {
        routerName: this.$route.name,
        notificationList: [],
        unReadNotificationTotal: 0,
        showLoader: false,
        currentPage: 1,
        limit: 20,
        totalNotificationsCount: 0,
        pendingRatingApps: [],
        requestCount: 0,
        enableSchedule: false,
    }
  },
  methods: {
    navigateTo(route) {
        //const query = { profileId: this.profileId, serialNumber: this.serialNumber };
        // Always close sidebar first
        this.closeNav();

        // Navigate
        this.$router.push(route).catch(() => {});
    },
    openNav() {
        document.getElementById("mySidebar").style.width = "100%";
        document.getElementById("mySidebar").style['max-width'] = "575px";
    },
    closeNav() {
        document.getElementById("mySidebar").style.width = "0px";
    },
    closeLogoutPopup() {
        $('#logoutPopup').collapse('hide');
    },
    openEnrollmentQrCodePopup() {
        $('#enrollmentQrCodePopup').collapse('show');
    },
    closeEnrollmentQrCodePopup() {
        $('#enrollmentQrCodePopup').collapse('hide');
    },
    async closeAppRatingPopup() {
        let data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId
        }
        await KidsService.markAsShownAppRating(data)
        .then((response) => {
            $('#appRatingPopup').collapse('hide');
        }).catch((e) => {
            $('#appRatingPopup').collapse('hide');
            this.$toast.error(e.response.data.respones_msg);
        });        
    },
    closeNotificationPopup() {
        $('#notificationsPopup').collapse('hide');
    },
    logout() {
        document.getElementById("mySidebar").style.width = "0px";
        $('#appRatingPopup').collapse('hide');
        $('#enrollmentQrCodePopup').collapse('hide');
        $('#notificationsPopup').collapse('hide');
        $('#logoutPopup').collapse('show');
    },
    doLogout() {   
        let data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId
        }     
        UserService.logout(data)
        .then((response) => {
            localStorage.setItem('token', "");
            localStorage.removeItem('token');
            this.$toast.success(response.data.respones_msg);
            
            if (localStorage.getItem('hideGoogleLogin') == "true") {
                document.location = "/login?hideGBtn=true";
            } else {
                this.$router.push('login');
            }
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getNotifications() {
        this.showLoader = true;
        let data = {
            serialNumber: this.serialNumber,
            currentPage: this.currentPage
        }
        $('#notificationsPopup').collapse('show');
        await KidsService.getNotifications(data)
        .then((response) => {
            this.showLoader = false;
            this.notificationList = response.data.data
            this.totalNotificationsCount = response.data.totalNotifications
            this.unReadNotificationTotal = 0
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    async unReadNotificationCount() {
        let data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId
        }
        await KidsService.unReadNotificationCount(data)
        .then((response) => {
            this.unReadNotificationTotal = response.data.data
            this.requestCount = response.data.appRequestCount
            this.enableSchedule = response.data.enableSchedule
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            if (e.response.data.is_logout == true) {
                this.$router.push({ path: '/login'})
            }
        });
    },
    async showMoreNotifications() {
        this.currentPage = this.currentPage + 1
        await this.getNotifications()
    },
    async getPendingRatingApps() {
        if (this.$route.name != "Kids Devices") {
            return;
        }
        let data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId
        }
        await KidsService.getPendingRatingApps(data)
        .then((response) => {
            this.pendingRatingApps = response.data.data;
            if (this.pendingRatingApps.length > 0) {
                //$('#appRatingPopup').collapse('show');
            }
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
        });
    },
    formatDate(date) {
        return new Date(date).toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      })
    }
  },
  watch: {
    serialNumber() {
        this.unReadNotificationCount();
        //this.getPendingRatingApps();
    }
  },
  beforeMount() {
    this.unReadNotificationCount();
    //this.getPendingRatingApps();
  },
}
</script>
<style scoped>
.notification-dot {
  position: absolute;
  top: -3px;
  right: -3px;   /* adjust this value depending on icon size */
  width: 10px;
  height: 10px;
  background: red;
  border-radius: 50%;
  border: 2px solid white;
}

.menu-icon-container {
    position: relative;
    display: inline-block;
}

.coming-soon-badge {
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 12px;
    background-color: #fbbf24; /* amber */
    color: #78350f;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
}

</style>